import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FnToasterService, FnSelectModule, FnUtilService } from 'foundation';
import { PosHttpService } from '../../../../../services/pos.http.service';

@Component({
  selector: 'app-mq-broker-model',
  templateUrl: './mq-broker-model.component.html',
  styleUrl: './mq-broker-model.component.scss'
})
export class MqBrokerModelComponent {

  constructor(@Inject(MAT_DIALOG_DATA) public dialogData: HwDialogData, private dialogRef: MatDialogRef<MqBrokerModelComponent>, private toaster: FnToasterService, private fnSelectModule: FnSelectModule, private posHttpSvcs: PosHttpService, private fnutilservice: FnUtilService) {
    if (!this.fnutilservice.isEmptyObject(this.dialogData.mqBroker)) {
      this.isEdit = true;
      this.objectHash.primaryKey = this.dialogData.mqBroker.primaryKey;
      this.objectHash.brokerName = this.dialogData.mqBroker.brokerName;
      this.objectHash.jmxConnectorPort = this.dialogData.mqBroker.jmxConnectorPort;
      this.objectHash.userName = this.dialogData.mqBroker.userName;
      this.objectHash.pssHash = this.dialogData.mqBroker.pssHash;
      this.objectHash.jmxDomainName = this.dialogData.mqBroker.jmxDomainName;
      this.objectHash.isUseJmx = this.dialogData.mqBroker.isUseJmx;
      this.objectHash.isActive = this.dialogData.mqBroker.isActive;
      this.objectHash.hostName = this.dialogData.mqBroker.hostName;
      this.objectHash.jmxUserName = this.dialogData.mqBroker.jmxUserName;
      this.objectHash.jmxPhash = this.dialogData.mqBroker.jmxPhash;
    }
  }
  isEdit = false;

  objectHash = {
    primaryKey: '',
    brokerName: '',
    jmxConnectorPort: 0,
    userName: '',
    pssHash: '',
    jmxDomainName: '',
    isUseJmx: false,
    isActive: false,
    hostName: '',
    jmxUserName: '',
    jmxPhash: ''
  }

  close() {
    this.dialogRef.close();
  }

  add() {
    if (this.fnutilservice.isEmptyObject(this.objectHash.hostName)) {
      this.toaster.error('Host Name can not be null');
      throw new Error();
    }
    if (this.fnutilservice.isEmptyObject(this.objectHash.brokerName)) {
      this.toaster.error('Broker Name can not be null');
      throw new Error();
    }
    this.dialogRef.close(this.objectHash);
  }
}

interface HwDialogData {
  mqBroker: any;
}
